module.exports = __webpack_public_path__ + "static/media/aloke_shetty.9841134f.jpg";